var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivatedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3514 1.05275C10.7251 0.734234 11.2749 0.734234 11.6486 1.05275L14.1212 3.15989C14.2814 3.29638 14.4805 3.37887 14.6903 3.39561L17.9287 3.65404C18.4182 3.6931 18.8069 4.08181 18.846 4.57132L19.1044 7.8097C19.1211 8.01946 19.2036 8.2186 19.3401 8.37877L21.4473 10.8514C21.7658 11.2251 21.7658 11.7749 21.4473 12.1486L19.3401 14.6212C19.2036 14.7814 19.1211 14.9805 19.1044 15.1903L18.846 18.4287C18.8069 18.9182 18.4182 19.3069 17.9287 19.346L14.6903 19.6044C14.4805 19.6211 14.2814 19.7036 14.1212 19.8401L11.6486 21.9473C11.2749 22.2658 10.7251 22.2658 10.3514 21.9473L7.87877 19.8401C7.71861 19.7036 7.51946 19.6211 7.3097 19.6044L4.07132 19.346C3.58181 19.3069 3.1931 18.9182 3.15404 18.4287L2.89561 15.1903C2.87887 14.9805 2.79638 14.7814 2.65989 14.6212L0.552748 12.1486C0.234234 11.7749 0.234234 11.2251 0.552747 10.8514L2.65989 8.37877C2.79638 8.21861 2.87887 8.01946 2.89561 7.8097L3.15404 4.57132C3.1931 4.08181 3.58181 3.6931 4.07132 3.65404L7.3097 3.39561C7.51946 3.37887 7.7186 3.29638 7.87877 3.15989L10.3514 1.05275Z",
    fill: "#4DEF42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.8498L10.1245 14.5L15 8.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivatedIcon);
export default __webpack_public_path__ + "static/media/activatedIcon.89fc5a3c47892c2826355112d77b135d.svg";
export { ForwardRef as ReactComponent };